import uniq from './uniq';
var union = function () {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return uniq([].concat.apply([], sources));
};
export default union;
//# sourceMappingURL=union.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/union.js
// module id = 530
// module chunks = 3